import React from 'react'
import { Text } from "@nextui-org/react";

function Signout() {
  return (
    <div className='accountForms'>
      <Text>
        Account Sign out
      </Text>

      <div className="border mt-8 border-blue-600 rounded-lg bg-red-50">
        <div className="px-4 py-5 sm:p-6">
          <div className="md:flex md:items-center md:justify-between">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />
            </svg>


            <div className="flex-1 max-w-xs mt-4 md:mt-0 md:ml-6">
              <p className="text-base font-bold text-gray-900">Sign out</p>
              <p className="mt-1 text-sm font-medium text-gray-500">Are you sure that you want to Sign out?</p>
            </div>

            <div className="flex items-center justify-start mt-6 space-x-6 md:ml-auto md:justify-end md:mt-0 md:space-x-reverse">
              <button
                type="button"
                className="inline-flex items-center justify-center px-6 py-3 text-sm font-semibold leading-5 text-white transition-all duration-200 
                bg-red-600 border border-transparent rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-600 hover:bg-red-800 md:order-last"
              >
                SIGN OUT
              </button>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Signout